module.exports = require("lodash/isEqual");


//////////////////
// WEBPACK FOOTER
// external "lodash/isEqual"
// module id = 61
// module chunks = 0